<template>
  <div>
    <el-dialog
      top="6vh"
      width="620px"
      center
      title="接单设置"
      :visible.sync="limitDialogVisible"
      :close-on-click-modal="false"
      @close="HandleCancel"
    >
      <el-form :rules="rules" :model="editData" :ref="form" label-width="110px">
        <el-row>
          <!-- <el-col :span="24">
            <el-form-item label="是否启用限额">
              <el-switch
                @change="HandleTriggerEnable($event)"
                v-model="editData.enable"
                :active-value="true"
                :inactive-value="false"
                active-color="#13ce66"
                inactive-color="#f56c6c"
              >
              </el-switch>
              {{ editData.enable === true ? "启用" : "否" }}
            </el-form-item>
          </el-col> -->
          <el-col :span="12">
            <el-form-item label="每日收款限额">
              <el-input-number
                :disabled="!editData.enable"
                :min="0"
                v-model="editData.dailyPaymentLimit"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="每日出款限额">
              <el-input-number
                :disabled="!editData.enable"
                :min="0"
                v-model="editData.dailyWithdrawalLimit"
              />
            </el-form-item>
          </el-col>
          <!-- <el-col :span="12">
            <el-form-item label="最小收款限额">
              <el-input-number
                :disabled="!editData.enable"
                :min="0"
                v-model="editData.minPaymentLimit"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="最大收款限额">
              <el-input-number
                :disabled="!editData.enable"
                :min="0"
                v-model="editData.maxPaymentLimit"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="最小出款限额">
              <el-input-number
                :disabled="!editData.enable"
                :min="0"
                v-model="editData.minWithdrawalLimit"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="最大出款限额">
              <el-input-number
                :disabled="!editData.enable"
                :min="0"
                v-model="editData.maxWithdrawalLimit"
              />
            </el-form-item>
          </el-col> -->
          <el-col :span="24" v-if="userInfo.userType === 'admin'">
            <el-form-item label="每日银行限额">
              <el-input-number
                :min="0"
                v-model="editData.withdrawDayLimitFromBank"
              />
            </el-form-item>
          </el-col>
          <el-col :span="24" v-if="editData.dispatchMode === 0">
            <el-divider></el-divider>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="payCd" label="支付冷却时间">
              <el-input
                clearable
                style="width: 100px"
                v-model="editData.payCd"
              />
              <span style="color: #409eff">
                &nbsp;{{ HandleTimeStampToDatetimeFormat(editData.payCd) }}
              </span>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="withdrawCd" label="提现冷却时间">
              <el-input
                clearable
                style="width: 100px"
                v-model="editData.withdrawCd"
              />
              <span style="color: #409eff">
                &nbsp;{{ HandleTimeStampToDatetimeFormat(editData.withdrawCd) }}
              </span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row v-if="feeRateListObj" class="settingFee">
          <el-col :span="12">
            <h4>收款</h4>
            <div>
              <el-checkbox-group
                size="mini"
                v-model="feeRateDataList.paySettingIds"
              >
                <el-checkbox-button
                  v-for="item in payFeeRateListArrange"
                  :key="item.settingId"
                  :label="item.settingId"
                  :disabled="!item.levelEnable"
                >
                  <div
                    :style="
                      userInfo.userType === 'kefu' ? 'padding: 8.5px 0' : ''
                    "
                  >
                    <i
                      v-if="
                        feeRateDataList.paySettingIds.indexOf(
                          item.settingId
                        ) !== -1
                      "
                      class="el-icon-check"
                    />
                    {{
                      `${formatNumberWithCommasAndDecimalSeparator(
                        item.minAmount,
                        0
                      )} - ${formatNumberWithCommasAndDecimalSeparator(
                        item.maxAmount,
                        0
                      )}`
                    }}
                  </div>
                  <div
                    class="sec-title"
                    v-if="
                      userInfo.commonUserType === 0 &&
                      userInfo.userType !== 'kefu'
                    "
                  >
                    {{
                      formatNumberWithCommasAndDecimalSeparator(
                        item.levelAmount,
                        2
                      ) === "0"
                        ? "暂免押金"
                        : `需押金：${formatNumberWithCommasAndDecimalSeparator(
                            item.levelAmount,
                            2
                          )}`
                    }}
                    <span
                      v-if="!item.levelEnable"
                      class="upgrade-tops"
                      :style="`animation-delay: ${
                        Math.random() * item.settingId * 0.3
                      }s`"
                      >请联络管理员提升押金！</span
                    >
                  </div></el-checkbox-button
                >
              </el-checkbox-group>
            </div>
          </el-col>
          <el-col :span="12">
            <h4>出款</h4>
            <div>
              <el-checkbox-group
                size="mini"
                v-model="feeRateDataList.withdrawSettingIds"
              >
                <el-checkbox-button
                  v-for="item in feeRateListObj.withdrawFeeRateList"
                  :key="item.settingId"
                  :label="item.settingId"
                  :disabled="!item.levelEnable"
                  ><div style="padding: 8.5px 0">
                    <i
                      v-if="
                        feeRateDataList.withdrawSettingIds.indexOf(
                          item.settingId
                        ) !== -1
                      "
                      class="el-icon-check"
                    />
                    {{
                      `${formatNumberWithCommasAndDecimalSeparator(
                        item.minAmount,
                        0
                      )} - ${formatNumberWithCommasAndDecimalSeparator(
                        item.maxAmount,
                        0
                      )}`
                    }}
                  </div>
                  <!-- <div class="sec-title">
                    {{
                      formatNumberWithCommasAndDecimalSeparator(
                        item.levelAmount,
                        2
                      ) === "0"
                        ? "暂免押金"
                        : `需押金：${formatNumberWithCommasAndDecimalSeparator(
                            item.levelAmount,
                            2
                          )}`
                    }}
                    <span
                      v-if="!item.levelEnable"
                      class="upgrade-tops"
                      :style="`animation-delay: ${
                        Math.random() * item.settingId * 0.3
                      }s`"
                      >请联络管理员提升押金！</span
                    >
                  </div> -->
                </el-checkbox-button>
              </el-checkbox-group>
            </div>
          </el-col>
        </el-row>
      </el-form>
      <span
        v-if="['sms_admin'].indexOf(userInfo.userType) === -1"
        slot="footer"
        class="dialog-footer"
      >
        <el-button round @click="HandleCancel"> 取消 </el-button>
        <el-button
          :loading="submitLoading"
          round
          type="success"
          @click="HandleVaild"
        >
          保存
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import mainCommon from "@/utils/mainCommon";
import { updateLimit } from "@/api/account";
import { updateFeeRateBatchSelect } from "@/api/user";

export default {
  mixins: [mainCommon],
  props: ["modules", "feeRateListObj"],
  data() {
    return {
      submitLoading: false,
      form: "form",
      rules: {
        payCd: [
          {
            message: "格式不符或必填项目为空",
            pattern: /^\d+$/g,
          },
        ],
        withdrawCd: [
          {
            message: "格式不符或必填项目为空",
            pattern: /^\d+$/g,
          },
        ],
      },
      payFeeRateListArrange: [], // 支付有金额区间需要特殊排序
      feeRateDataList: {
        paySettingIds: [],
        withdrawSettingIds: [],
      },
    };
  },
  watch: {
    feeRateListObj(val) {
      // ========== Start 特殊规则，minAmount 为 500 且 maxAmount 为 5000 区间放到最后面
      this.payFeeRateListArrange = val.payFeeRateList;
      const targetObject = this.payFeeRateListArrange.find(
        (obj) => obj.minAmount === "500.0000" && obj.maxAmount === "5000.0000"
      );
      if (targetObject) {
        const index = this.payFeeRateListArrange.indexOf(targetObject);
        if (index !== -1) {
          this.payFeeRateListArrange.splice(index, 1);
          this.payFeeRateListArrange.push(targetObject);
        }
      }
      // ========== End 特殊规则，minAmount 为 500 且 maxAmount 为 5000 区间放到最后面

      val.payFeeRateList.forEach((i) => {
        if (i.isSelected) {
          this.feeRateDataList.paySettingIds.push(i.settingId);
        }
      });
      val.withdrawFeeRateList.forEach((i) => {
        if (i.isSelected) {
          this.feeRateDataList.withdrawSettingIds.push(i.settingId);
        }
      });
    },
  },
  computed: {
    editData() {
      return this.$store.state[this.modules].limitEditData;
    },
    limitDialogVisible: {
      get() {
        return this.$store.state[this.modules].limitDialogVisible;
      },
      set(val) {
        this.HandleSetState(this.modules, "/SET_STATE", {
          limitDialogVisible: val,
        });
      },
    },
  },
  methods: {
    HandleTriggerEnable($event) {
      this.editData.enable = $event;
    },
    HandleCancel() {
      this.HandleSetState(this.modules, "/SET_STATE", {
        limitDialogVisible: false,
      });
      this.feeRateDataList = {
        paySettingIds: [],
        withdrawSettingIds: [],
      };
    },
    HandleVaild() {
      this.$refs[this.form].validate((valid) => {
        if (valid) this.HandleSubmit();
      });
    },
    HandleSubmit() {
      // CD 时间范围
      if (this.editData.payCd < 1 || this.editData.payCd > 7200) {
        return this.$notify.error("支付CD时间超出范围1 - 7200秒");
      }

      if (this.editData.withdrawCd < 1 || this.editData.withdrawCd > 7200) {
        return this.$notify.error("提现CD时间超出范围1 - 7200秒");
      }

      // 无论收出款，至少要选择一个区间
      if (
        this.feeRateDataList.paySettingIds.length < 1 &&
        this.feeRateDataList.withdrawSettingIds.length < 1
      ) {
        return this.$notify.error("接单金额区间为必选项目");
      }
      // 更新收、付款区间
      this.submitLoading = true;
      updateFeeRateBatchSelect(
        this.HandleGetState(this.modules, "id"),
        this.feeRateDataList
      ).then(() => {
        updateLimit(this.HandleGetState(this.modules, "id"), this.editData)
          .then((res) => {
            this.$notify.success(res.message);
            this.HandleCancel();
            this.$emit("HandleGetList");
          })
          .catch(() => {})
          .finally(() => {
            this.submitLoading = false;
          });
      });
    },
  },
};
</script>

<style lang="scss">
.settingFee {
  h4 {
    font-size: 16px;
    padding: 0;
    margin: 0px 0 4px;
    width: 100%;
  }
  .el-checkbox-button {
    display: block;
    .el-checkbox-button__inner {
      font-weight: 600;
      font-size: 15px;
      line-height: 17px;
      width: 99%;
      margin-bottom: 6px;
      border-radius: 4px;
      border: 1px solid #dcdfe6;
      box-shadow: none;
      .sec-title {
        position: relative;
        color: #e1ca42;
        .upgrade-tops {
          font-size: 20px;
          color: #ffb9b9;
          animation: upgrade-animation 2s ease-out infinite;
          position: absolute;
          left: 50%;
          transform: translateX(-50%);
          margin-left: 6px;
          top: -10px;
        }
        @keyframes upgrade-animation {
          0% {
            opacity: 1;
          }
          100% {
            opacity: 0;
          }
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/views/account/bank/LimitDialog.vue